import * as TYPES from './mutationTypes'

export default {
  //通道列表
  [TYPES.GET_OFFCHAIN_CHAN_LIST](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      chan_list: payload.result.items,
      chan_paging: { limit, offset, total }
    })
  },

  //通道交易列表
  [TYPES.GET_OFFCHAIN_TX_LIST](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      tx_list: payload.result.items,
      tx_paging: { limit, offset, total }
    })
  },

  //通道内交易列表
  [TYPES.GET_OFFCHAIN_CHAN_TX_LIST](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      chan_tx_list: payload.result.items,
      chan_tx_paging: { limit, offset, total }
    })
  },

  balanceChange(state, data) {
    state.balance = data
  }
}
